export default __webpack_public_path__ + "static/media/Background_00049.29102041.png";